import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {trainingPageText as trainingPageText_en} from "../libs/en/texts-training-page-lib";
import {trainingPageText as trainingPageText_en_ca} from "../libs/en-ca/texts-training-page-lib";
import {trainingPageText as trainingPageText_de} from "../libs/de/texts-training-page-lib";
import {trainingPageText as trainingPageText_de_ch} from "../libs/de-ch/texts-training-page-lib";
import {trainingPageText as trainingPageText_fr} from "../libs/fr/texts-training-page-lib";
import {trainingPageText as trainingPageText_fr_ca} from "../libs/fr-ca/texts-training-page-lib";
import {trainingPageText as trainingPageText_nl} from "../libs/nl/texts-training-page-lib";
import {trainingPageText as trainingPageText_it} from "../libs/it/texts-training-page-lib";
import {trainingPageText as trainingPageText_it_ch} from "../libs/it-ch/texts-training-page-lib";
import {trainingPageText as trainingPageText_cz} from "../libs/cz/texts-training-page-lib";
import {trainingPageText as trainingPageText_fi} from "../libs/fi/texts-training-page-lib";
import {trainingPageText as trainingPageText_pl} from "../libs/pl/texts-training-page-lib";
import {trainingPageText as trainingPageText_se} from "../libs/se/texts-training-page-lib";
import {trainingPageText as trainingPageText_no} from "../libs/no/texts-training-page-lib";
import {trainingPageText as trainingPageText_dk} from "../libs/dk/texts-training-page-lib";
import {trainingPageText as trainingPageText_es} from "../libs/es/texts-training-page-lib";
import {trainingPageText as trainingPageText_pt} from "../libs/pt/texts-training-page-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {GOOGLE_PLAY_APP_URL, APPLE_APP_STORE_URL} from "../utils/appStoreLinks";
import {AdditionalResourcesSection} from './AdditionalResourcesSection';
import fileIcon from '../assets/images/file-ic.svg';
import {userTrainingPageText as userTrainingPageText_en} from "../libs/en/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_en_ca} from "../libs/en-ca/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_de} from "../libs/de/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_de_ch} from "../libs/de-ch/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr} from "../libs/fr/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr_fr} from "../libs/fr-fr/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fr_ca} from "../libs/fr-ca/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_nl} from "../libs/nl/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_it} from "../libs/it/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_it_ch} from "../libs/it-ch/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_cz} from "../libs/cz/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_fi} from "../libs/fi/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_pl} from "../libs/pl/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_se} from "../libs/se/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_no} from "../libs/no/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_dk} from "../libs/dk/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_es} from "../libs/es/texts-user-training-page-lib";
import {userTrainingPageText as userTrainingPageText_pt} from "../libs/pt/texts-user-training-page-lib";

const TRAINING_BY_LANGUAGE = {
    EN: trainingPageText_en,
    'EN-CA': trainingPageText_en_ca,
    DE: trainingPageText_de,
    'DE-CH': trainingPageText_de_ch,
    FR: trainingPageText_fr,
    'FR-FR': trainingPageText_fr,
    'FR-CA': trainingPageText_fr_ca,
    NL: trainingPageText_nl,
    IT: trainingPageText_it,
    'IT-CH': trainingPageText_it_ch,
    CZ: trainingPageText_cz,
    FI: trainingPageText_fi,
    PL: trainingPageText_pl,
    SE: trainingPageText_se,
    NO: trainingPageText_no,
    DK: trainingPageText_dk,
    ES: trainingPageText_es,
    PT: trainingPageText_pt,
};

const USER_TRAINING_BY_LANGUAGE = {
    EN: userTrainingPageText_en,
    'EN-CA': userTrainingPageText_en_ca,
    DE: userTrainingPageText_de,
    'DE-CH': userTrainingPageText_de_ch,
    FR: userTrainingPageText_fr,
    'FR-FR': userTrainingPageText_fr_fr,
    'FR-CA': userTrainingPageText_fr_ca,
    NL: userTrainingPageText_nl,
    IT: userTrainingPageText_it,
    'IT-CH': userTrainingPageText_it_ch,
    CZ: userTrainingPageText_cz,
    FI: userTrainingPageText_fi,
    PL: userTrainingPageText_pl,
    SE: userTrainingPageText_se,
    NO: userTrainingPageText_no,
    DK: userTrainingPageText_dk,
    ES: userTrainingPageText_es,
    PT: userTrainingPageText_pt,
};

const LANGUAGE_PREFIX = {
    EN: '',
    'EN-CA': '/en-ca',
    DE: '/de',
    'DE-CH': '/de-ch',
    FR: '/fr-ch',
    'FR-FR': '/fr',
    'FR-CA': '/fr-ca',
    NL: '/nl',
    IT: '/it',
    'IT-CH': '/it-ch',
    CZ: '/cz',
    FI: '/fi',
    PL: '/pl',
    SE: '/se',
    NO: '/nb',
    DK: '/dk',
    ES: '/es',
    PT: '/pt',
};

// Tab for HCP training
export class TrainingHCP extends Component {

    constructor(props) {
        super(props);
        const language = this.props.language;
        this.state = {
            language,
            trainingPageText: TRAINING_BY_LANGUAGE[language] || trainingPageText_en,
            prefix: LANGUAGE_PREFIX[language] || '',
            isVideoPlaying: false,
            showVideo: true,
        };
        this.videoRef = React.createRef();
        this.handleVideoPlay = this.handleVideoPlay.bind(this);
        this.handleVideoPause = this.handleVideoPause.bind(this);
        this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            const language = this.props.language;
            this.setState({
                language,
                trainingPageText: TRAINING_BY_LANGUAGE[language] || trainingPageText_en,
                prefix: LANGUAGE_PREFIX[language] || '',
            });
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.videoRef.current) {
            this.videoRef.current.play().catch(() => {
                // Autoplay might be blocked by browser
            });
        }
    }

    handlePlayButtonClick() {
        this.setState({showVideo: true, isVideoPlaying: true}, () => {
            if (this.videoRef.current) {
                this.videoRef.current.play();
            }
        });
    }

    handleVideoPlay() {
        this.setState({isVideoPlaying: true});
    }

    handleVideoPause() {
        this.setState({isVideoPlaying: false});
    }

    getUserTrainingPageText() {
        return USER_TRAINING_BY_LANGUAGE[this.state.language] || userTrainingPageText_en;
    }

    render() {
        const text = this.state.trainingPageText;

        return (
            <div>
                <Helmet>
                    <title>{parse(text.title)}</title>
                    <meta name="title" content={parse(text.titleMeta)}/>
                    <meta name="description" content={parse(text.descriptionMeta)}/>
                    <meta property="og:locale" content={text.localeMeta}/>
                    <meta name="keywords" content={text.keywords}/>
                </Helmet>
                <Header props={this.props}/>

                <section className="inner-banner user-training-page">
                    <div className="container">
                        <div className="justify-content-center">
                            <div className="user-training-header">
                                <h1 style={{
                                    color: '#04ABA0',
                                    fontSize: '40px',
                                    fontWeight: '700',
                                    textAlign: 'center',
                                    marginBottom: '8px'
                                }}>{parse(text.mainHeader)}</h1>
                                <p style={{
                                    color: '#3C3C3C',
                                    fontSize: '32px',
                                    fontWeight: '300',
                                    textAlign: 'center',
                                    marginBottom: '20px',
                                    width: '100%',
                                    maxWidth: '1049px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}>{parse(text.mainSubHeader)}</p>
                            </div>
                        </div>
                    </div>
                </section>

                {text.quickResourceLinksHeader && text.quickResourceLinks && text.quickResourceLinks.length > 0 && (
                    <section className="hcp-quick-resources">
                        <div className="container">
                            <h2 className="hcp-quick-resources-title">{parse(text.quickResourceLinksHeader)}</h2>
                            <div className="row hcp-quick-resources-row">
                                {text.quickResourceLinks.map((item, index) => (
                                    <div className="col-12 col-md-4" key={index}>
                                        <div className="hcp-quick-resource-item">
                                            <img
                                                src={fileIcon}
                                                alt=""
                                                className="hcp-quick-resource-icon"
                                            />
                                            <div className="hcp-quick-resource-content">
                                                <p className="hcp-quick-resource-item-title">{parse(item.title)}</p>
                                                <a
                                                    href={item.url || '#'}
                                                    className="hcp-quick-resource-download"
                                                    {...(item.url && item.url !== '#' ? {
                                                        target: '_blank',
                                                        rel: 'noopener noreferrer',
                                                    } : {})}
                                                    onClick={(e) => {
                                                        if (!item.url || item.url === '#') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                >
                                                    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z" fill="#04ABA0"/>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M1 17H14V19H1V17Z" fill="#04ABA0"/>
                                                    </svg>
                                                    <span>{parse(text.quickResourceDownload || 'Download')}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                )}

                <section className="getting-started-section" style={{
                    background: 'linear-gradient(180deg, rgba(37, 139, 204, 1) 0%, rgba(4, 171, 160, 1) 100%)',
                    padding: '75px 0px 80px',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-12 col-lg-6">
                                <h2 style={{
                                    fontSize: '32px',
                                    fontWeight: '300',
                                    color: '#FFFFFF',
                                    marginBottom: '27px',
                                    fontFamily: 'Roboto'
                                }}>{parse(text.gettingStartedHeader)}</h2>

                                <div style={{marginBottom: '40px', marginTop: '-10px'}}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '16px',
                                        lineHeight: '1.5'
                                    }}>{parse(text.step1Title)}</h3>
                                    <div className="logo-container" style={{display: 'flex', gap: '16px', flexWrap: 'wrap'}}>
                                        <a href={GOOGLE_PLAY_APP_URL}
                                           target="_blank"
                                           rel="noopener noreferrer">
                                            <img src="/images/google-play-badge.png"
                                                 alt="Get it on Google Play"
                                                 loading="lazy"
                                                 decoding="async"
                                                 style={{height: '72px', width: 'auto'}}/>
                                        </a>
                                        <a href={APPLE_APP_STORE_URL}
                                           target="_blank"
                                           rel="noopener noreferrer">
                                            <img src="/images/app-store.png"
                                                 alt="Download on App Store"
                                                 loading="lazy"
                                                 decoding="async"
                                                 style={{height: '72px', width: 'auto'}}/>
                                        </a>
                                    </div>
                                </div>

                                <div style={{marginBottom: '40px'}}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight: '1.5'
                                    }}>{parse(text.step2Title)}</h3>
                                </div>

                                <div style={{marginBottom: '40px'}}>
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight: '1.5'
                                    }}>{parse(text.step3Title)}</h3>
                                </div>

                                <div className="step-4-container">
                                    <h3 style={{
                                        fontSize: '24px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '300',
                                        color: '#FFFFFF',
                                        marginBottom: '8px',
                                        lineHeight: '1.5'
                                    }}>
                                        <span>{parse(text.step4Title)}</span>
                                        <span className="tooltip-container" style={{
                                            position: 'relative',
                                            top: '-2px',
                                            display: 'inline-block',
                                            marginLeft: '7px'
                                        }}>
                                            <img
                                                src="/images/info-circle.svg"
                                                alt="Info"
                                                loading="lazy"
                                                decoding="async"
                                                style={{
                                                    width: '22px',
                                                    height: '22px',
                                                    cursor: 'pointer',
                                                    verticalAlign: 'middle'
                                                }}
                                                onMouseOver={e => {
                                                    const tooltip = e.currentTarget.nextSibling;
                                                    if (tooltip) tooltip.style.display = 'block';
                                                }}
                                                onMouseOut={e => {
                                                    const tooltip = e.currentTarget.nextSibling;
                                                    if (tooltip) tooltip.style.display = 'none';
                                                }}
                                            />
                                            <span
                                                style={{
                                                    display: 'none',
                                                    position: 'absolute',
                                                    left: '110%',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#fff',
                                                    color: '#000',
                                                    padding: '22px 20px',
                                                    borderTopRightRadius: '12px',
                                                    borderBottomRightRadius: '12px',
                                                    borderBottomLeftRadius: '12px',
                                                    fontSize: '20px',
                                                    fontFamily: 'Roboto',
                                                    zIndex: 100,
                                                    fontWeight: '300',
                                                    lineHeight: '1.171875',
                                                    width: '330px',
                                                    whiteSpace: 'normal'
                                                }}
                                            >
                                               Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.
                                            </span>
                                        </span>
                                    </h3>
                                </div>
                            </div>

                            <div className="col-12 col-lg-6 phone-mockup-container">
                                <div className="phone-mockup-wrapper">
                                    <img src="/images/phone-mockup-61359e.png"
                                         alt="CamAPS FX App"
                                         decoding="async"
                                         className="phone-mockup-image"/>
                                    <div className="phone-mockup-video-container">
                                        <video
                                            ref={this.videoRef}
                                            controls={false}
                                            className="phone-mockup-video"
                                            onPlay={this.handleVideoPlay}
                                            onPause={this.handleVideoPause}
                                            onEnded={this.handleVideoPause}
                                            playsInline
                                            autoPlay
                                            muted
                                            loop
                                        >
                                            <source src={text.videoSrc} type="video/mp4"/>
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <AdditionalResourcesSection
                    language={this.state.language}
                    prefix={this.state.prefix}
                    userTrainingPageText={this.getUserTrainingPageText()}
                />

                <section className="support-section hcp-certified-section">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-12 col-lg">
                                <h3>
                                    {parse(text.certifiedTrainingTitle)}
                                </h3>
                                <p>
                                    {parse(text.trainingHeaderText)}
                                </p>
                            </div>

                            <div className="col-12 col-lg-auto d-flex justify-content-center justify-content-lg-end">
                                <a
                                    href={text.websiteLink}
                                    title={text.websiteLinkHeading}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="support-button support-button-rounded"
                                >
                                    {parse(text.getTrained)}
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer props={this.props}/>
            </div>
        );
    }
}
